import React from 'react';
import { useData } from '../Data';
import { StaffList } from './List';

// The team: the strip of video tiles and the lists by position; "#alumni" shows the former members.
// A person's own page and the menu beside the list come from the server.
export function StaffRoot() {
  const { current } = useData();
  return <StaffList alumni={current === 'alumni'} />;
}
